export const lightTheme = {
  background: '#363537',
  body: '#FFF',
  text: '#363537',
  toggleBorder: '#FFF',
};

export const darkTheme = {
  background: '#999',
  body: '#181a1b',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
};
